/* eslint-disable @typescript-eslint/no-explicit-any */

import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { PencilIcon /* Trash2Icon */, TriangleIcon } from "lucide-react";
import { Fragment } from "react/jsx-runtime";
export const ReactTable = ({
  onAction,
  data,
  activePermission,
  sortingHandler,
  sortBy,
  orderBy,
}: any) => {
  return (
    <Fragment>
      <Table style={{ borderCollapse: "collapse", width: "100%" }}>
        <TableHeader>
          <TableRow>
            <TableHead className="pl-4">Merged Retailer</TableHead>
            <TableHead>
              <span
                onClick={() => sortingHandler("retailer_name")}
                className="flex items-center gap-1 w-full"
              >
                Retailers
                <span>
                  {sortBy === "retailer_name" ? (
                    <TriangleIcon
                      className={cn(orderBy ? "rotate-180" : "")}
                      fill="#1f2937"
                      stroke="#1f2937"
                      size={8}
                    />
                  ) : (
                    <span>
                      <TriangleIcon fill="#1f2937" stroke="#1f2937" size={8} />
                      <TriangleIcon
                        className={"rotate-180"}
                        fill="#1f2937"
                        stroke="#1f2937"
                        size={8}
                      />
                    </span>
                  )}
                </span>
              </span>
            </TableHead>
            <TableHead className="text-center sticky right-0 z-[2] w-auto pr-0">
              <div className="flex justify-end">
                <div className="w-[66px] md:w-[135px] text-left pl-[8px]">
                  Actions
                </div>
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row: any, rowIndex: number) => {
            return (
              <TableRow key={rowIndex}>
                <TableCell className="pl-2">{row?.retailer_name}</TableCell>
                <TableCell isLineClampDisable={true} className="pl-2">
                  {row?.linked_retailers?.map((item: any, index: number) => {
                    return (
                      <div
                        key={`${item.retailer_name}-${rowIndex}-${index} mb-1 pl-3`}
                      >
                        {item.retailer_name}
                        {item.is_primary ? (
                          <TooltipProvider delayDuration={0}>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <span className="bg-primary text-white w-[17px] h-[17px] inline-flex items-center justify-center text-[11px] ml-1 aspect-square rounded-full">
                                  P
                                </span>
                              </TooltipTrigger>
                              <TooltipContent>
                                <p>Primary</p>
                                <TooltipArrow />
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        ) : (
                          ""
                        )}
                      </div>
                    );
                  })}
                  {/* <ReactTableCell header={cell.key} value={cell.value} /> */}
                </TableCell>
                <TableCell
                  className="text-right sticky right-0 w-auto bg-white"
                  nestedClassName="pr-0"
                >
                  <div className="flex items-center justify-end z-[2] bg-white">
                    <div className="flex items-center w-[66px] md:w-[135px]">
                      <TooltipProvider>
                        {activePermission?.update ? (
                          <Tooltip>
                            <TooltipTrigger asChild>
                              <Button
                                variant={"ghost"}
                                size={"icon"}
                                className="text-primary"
                                onClick={() =>
                                  onAction({
                                    data: row,
                                    action: "edit",
                                  })
                                }
                              >
                                <PencilIcon />
                              </Button>
                            </TooltipTrigger>
                            <TooltipContent>
                              <p>Edit</p>
                              <TooltipArrow />
                            </TooltipContent>
                          </Tooltip>
                        ) : null}

                        {/* <Tooltip>
                          <TooltipTrigger asChild>
                            <Button
                              variant={"ghost"}
                              size={"icon"}
                              className="text-primary"
                              onClick={() =>
                                onAction({
                                  data: row,
                                  action: "delete",
                                })
                              }
                            >
                              <Trash2Icon />
                            </Button>
                          </TooltipTrigger>

                          <TooltipContent>
                            <p>Delete</p>
                            <TooltipArrow />
                          </TooltipContent>
                        </Tooltip> */}
                      </TooltipProvider>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Fragment>
  );
};
